import { ITitleMultiRowCardsButton, IItem } from './types';
import { mapTitleMultiRowCardsButton } from './mapTitleMultiRowCardsButton';
import { RichText } from 'prismic-reactjs';
import LazyImage from '@monofront/design-system/components/LazyImage';
import CustomPrismicLink from '@components/CustomPrismicLink';
import withSlice from '@screens/SlicesContainer/withSlice';

const TitleMultiRowCardsButton: React.FC<ITitleMultiRowCardsButton> = ({
  backgroundImage,
  items,
  title,
}) => {
  return (
    <section className="root">
      <RichText render={title} />
      <div className="container">
        {items.map((item: IItem, index: number) => {
          return (
            <div key={index} className="tw-rounded-2xl tw-bg-white">
              <LazyImage src={item.image} alt={item.alt} />
              <RichText
                render={item.text}
                serializeHyperlink={CustomPrismicLink}
              />
            </div>
          );
        })}
      </div>
      <style jsx>{`
        .root {
          background-image: url(${backgroundImage});
          background-size: contain;
          background-repeat: no-repeat;
          background-position: 0 50px;
        }

        .root :global(h1) {
          text-align: center;
          margin-bottom: var(--space-4);
        }

        .root :global(img) {
          width: 85px;
        }

        .root :global(p) {
          padding-top: 15px;
        }

        .container {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          grid-gap: 20px;
          text-align: center;
        }

        .container > :global(div) {
          padding: var(--space-5);
        }

        .container :global(img) {
          width: 100px;
          margin-bottom: var(--space-4);
        }

        .cta-button {
          text-align: center;
        }

        @media (max-width: 800px) {
          .root {
            background: none;
          }

          .container {
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            grid-gap: 10px;
          }
        }
      `}</style>
    </section>
  );
};

export default withSlice(TitleMultiRowCardsButton, mapTitleMultiRowCardsButton);
